import ModalPopup from "../../../components/newcomponents/ModalPopup";
import NotesCheckBox from "./NoteCheckBox";
import backarrow from "../images/backarrow.svg";
import MedicalReport from "../../contentReaderMarkdown/markdownRenderer";
import TemplateSkeleton from "./TemplateSkeleton";

const TemplateSummaryComp = ({ onModalTapped, templateSummary, UpdateNotes, loading }) => {
   const modifiedText = templateSummary?.sample;
   const paraText = modifiedText?.replace(/[#*]/g, "");
   return (
      <>
         <ModalPopup onModalTapped={onModalTapped}>
            <div className=" template-modalPopup box-shadow ">
               {loading ? (
                  <TemplateSkeleton />
               ) : (
                  <>
                     <div className="temp-summary-flex-container">
                        <div className="d-flex align-items-center cursor-pointer">
                           <div>
                              <img
                                 onClick={onModalTapped}
                                 src={backarrow}
                                 alt=""
                                 style={{ width: "20px", height: "20px" }}
                                 className="item"
                              />
                           </div>
                        </div>
                        <div className="temp-summary-title-text ml-4">{templateSummary?.title}</div>
                        <div>
                           <div className="item">
                              <NotesCheckBox
                                 width="51px"
                                 height="31px"
                                 tempId={templateSummary?.id}
                                 isDisable={templateSummary?.isDisable}
                                 UpdateNotes={UpdateNotes}
                              />
                           </div>
                        </div>
                     </div>
                     <div className="summary-para-text custom-temp-truncate ">{paraText}</div>
                     <div className="summary-container">
                        {/* <div className="text-center summary-title-text">Sample Note</div> */}
                        <div className="scrole-width-temp  scrollbar-notes">
                           <MedicalReport content={templateSummary?.sample} />
                        </div>
                     </div>
                  </>
               )}
            </div>
         </ModalPopup>
      </>
   );
};

export default TemplateSummaryComp;
